export default __webpack_public_path__ + "static/media/sponsor-banner-id.24873517.webp";